import { Injectable } from '@angular/core';
import Config         from './config';

@Injectable()
export class ConfigService {
  getApiUrl() {

    return Config.ApiUrl;
  }

  getApiRoot() {

    return Config.ApiRoot;
  }

  getDeleteConfirmObject() {
    return {
      title: '¿Esta seguro?',
      text: 'Usted se dispone a eliminar este registro',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#B71C1C',
      confirmButtonText: 'Si, eliminalo',
      cancelButtonColor: '#ECEFF1',
      cancelButtonText: 'Cancelar',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    };
  }

  getSaveSuccessObject() {
    return {
      title: 'Guardado!',
      text: 'Su registro ha sido guardado correctamente.',
      type: 'success',
      confirmButtonText: "Aceptar"
    };
  }

  getDeleteSuccessObject() {
    return {
      title: 'Eliminado!',
      text: 'Su registro ha sido eliminado correctamente.',
      type: 'success',
      confirmButtonText: "Aceptar"
    };
  }

  getErrorSaveObject() {
    return {
      title: 'Error',
      text: 'Se presento un error al guardar el registro',
      type: 'error',
      confirmButtonText: 'Aceptar',
      closeOnConfirm: false              
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/configuracion/config.service.ts